import { IGroupTemplate } from 'fitbeat.models';
import React from 'react';
import IntlMessages from '../../../util/IntlMessages';
import TemplateRow from './TemplateRow';

interface ITemplateSectionProps {
  titleId: string;
  templates: IGroupTemplate[];
  selectedTemplateIds: string[];
  isSaving: boolean;
  isAlreadyCreated: (template: IGroupTemplate) => boolean;
  onToggle: (templateId: string) => void;
}

const TemplateSection: React.FC<ITemplateSectionProps> = ({
  titleId,
  templates,
  selectedTemplateIds,
  isSaving,
  isAlreadyCreated,
  onToggle,
}) => {
  if (templates.length === 0) {
    return null;
  }
  return (
    <div className='group-catalogue__section'>
      <h3 className='group-catalogue__section-header'><IntlMessages id={titleId} /></h3>
      {templates.map((template) => (
        <TemplateRow
          key={template._id}
          template={template}
          checked={selectedTemplateIds.includes(template._id)}
          alreadyCreated={isAlreadyCreated(template)}
          isSaving={isSaving}
          onToggle={onToggle}
        />
      ))}
    </div>
  );
};

export default TemplateSection;
